import React, { useState, useEffect } from "react";
import { Table, Tag, Input } from "antd";
import {
  EyeFilled,
  DownloadOutlined,
  EyeInvisibleFilled,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { CSVLink } from "react-csv";
import { generateFilename } from "../../Helpers/Constane";
import CphActions from "../../redux/customer_payment_history/actions";
import SearchBar from "../../utils/Searchbar";
import HistoryModel from "./Modal/CustomerModel";
import "./CustomerPaymentHistory.scss";
import { maskNumber, maskEmail } from "../../utils/maskMobileNum";
const columns = [
  {
    title: "#",
    dataIndex: "key",
    key: "key",
    sorter: (a, b) => a.key-b.key,
    width: 100, // Fixed width
  },
  {
    title: "CUSTOMER NAME",
    dataIndex: "cus_name",
    sorter: (a, b) => String(a.cus_name || '').localeCompare(String(b.cus_name || '')),
    width: 100, // Fixed width
  },
  {
    title: "CUSTOMER EMAIL",
    dataIndex: "cus_email",
    sorter: (a, b) => String(a.cus_email || '').localeCompare(String(b.cus_email || '')),
    width: 100, // Fixed width
  },
  {
    title: "MOBILE NO.",
    dataIndex: "mob_no",
    width: 100, // Fixed width
  },

  {
    title: "AADHAR NO",
    dataIndex: "addhar_no",
    width: 100, // Fixed width
  },
  {
    title: "HISTORY",
    dataIndex: "history",
    width: 100, // Fixed width
  },
];

const { getCphData,getCphDetailData } = CphActions;

function CustomerPaymentHistory() {
  const dispatch = useDispatch();
  // const [formatDate, setFromDate] = useState("");
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 100,
  });
  
  const { cphResponseData, totalData, loading } = useSelector(
    (state) => state.chpReducer
  );
  const [historyModel, setHistoryModel] = useState(false);
  const [transactionHistory, setTransactionHistory] = useState([]);
  const { agentId } = useSelector((state) => ({
    agentId: state.authReducer.agentId,
  }));

  const handleCancel = () => {
    dispatch(getCphData(0, 100,"",agentId))
    setHistoryModel(false);
    setTransactionHistory([]);
  };

  const data =
    cphResponseData &&
    cphResponseData?.length > 0 &&
    cphResponseData?.map((items, index) => {
      return {
        key: (tableParams.current - 1) * tableParams.pageSize + index + 1,
        mob_no: maskNumber(items.mobileNumber) || <Tag>{""} </Tag>,
        cus_email: items.email || <Tag>{""} </Tag>,
        cus_name: items.name || <Tag>{""} </Tag>,
        addhar_no: items.aadhaar || <Tag>{""} </Tag>,
        history: (
          <>
            {historyModel ? (
              <EyeInvisibleFilled
                style={{
                  fontSize: "18px",
                  color: "#073763",
                  marginLeft: "10px",
                }}
                onClick={handleCancel}
              />
            ) : (
              <EyeFilled
                style={{
                  fontSize: "18px",
                  color: "#073763",
                  marginLeft: "10px",
                }}
                onClick={() => handleViewHistroy(items)}
              />
            )}
          </>
        ),
      };
    });

  const handleViewHistroy = (data) => {
    dispatch(getCphDetailData(data?.mobileNumber,"","","","","",agentId))
    setHistoryModel(true);
    setTransactionHistory(data);
  };

  let timeoutId;
  const handleFilterChange = (e) => {
    // debugger
    e.preventDefault();
    const value = e.target.value;
    if (timeoutId) {
      clearTimeout(timeoutId); // Clear the previous timeout if it exists
    }
    timeoutId = setTimeout(() => {
      if(cphResponseData?.length >= 0){
        dispatch(getCphData(0, 100, value,agentId));
      }
    }, 1000);
  };

  const handlePageChange = async (pagination, sofilters, rter) => {
    const { current, pageSize } = pagination;
    setTableParams({ current, pageSize });
    dispatch(getCphData(current, pageSize,"",agentId));
  };

  const exportData =
    cphResponseData &&
    cphResponseData?.length > 0 &&
    cphResponseData?.map((items, index) => {
      return {
        mob_no: items.mobileNumber,
        cus_email: items.email,
        cus_name: items.name,
        addhar_no: items.aadhaar,
      };
    });
  
  
    useEffect(() => {
      if (!agentId || agentId=="") {
        dispatch(getCphData());
      }else{
        dispatch(getCphData(0, 100,"",agentId));
      }
    }, [agentId, dispatch]);

  return (
    <>
      <div className="mainContain">
        <h1 className="transaction">Customer Payment History</h1>
        <div className="datesearchFi">
          <div className="">
            <div
              style={{
                width: "350px",
                outline: "none",
                border: "none",
                padding: "4px 8px",
                borderRadius: "4px",
              }}
            >
              {/* <input
                type="text"
                className="form-control"
                style={style}
                placeholder="Type here to search..."
                onChange={onChange}
            /> */}
              <Input
                size="default size"
                placeholder="Search"
                onChange={handleFilterChange}
              />
            </div>
            
          </div>
          {/* {data?.length > 0 ? (
            <div className="exportBtnDiv">
              <CSVLink
                filename={generateFilename("customer_payment_History")}
                data={exportData ? exportData : []}
                className="btn exportBtn"
              >
                <DownloadOutlined />
                Export
              </CSVLink>
            </div>
          ) : (
            ""
          )} */}
        </div>

        <div className="mt-3">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            scroll={{ x: 600 }}
            pagination={{
              total: totalData, // totalData,
              current: tableParams.current,
              pageSize: tableParams.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "50", "100", "500"],
            }}
            onChange={handlePageChange}
          />
        </div>
      </div>
      <HistoryModel
        fromTitle="Transaction Detail"
        open={historyModel}
        handleCancel={handleCancel}
        transactionHistory={transactionHistory}
        agentId={agentId}
      />
    </>
  );
}

export default CustomerPaymentHistory;
